// @flow
import React from "react";

import Selector from '../index';
import type { Props } from '../index'
import { useMateriaux } from 'redux/hooks'


export default ({ value, onChange, ...props }: Props) => {

    const data = useMateriaux();

    return (
        <Selector
            {...props}
            label="Sélection des matériaux"
            value={value}
            onChange={onChange}
            data={data}
        />
    )
};